export default __webpack_public_path__ + "static/media/payment_error.6f77d040.svg";